
import { ContractorsList } from "@/components/ContractorsList";
import { Contractor, ViewMode } from "@/types/contractor";

interface ContractorsSectionProps {
  contractors: Contractor[];
  isLoading: boolean;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  onServiceTypeChange: (type: string) => void;
  onLocationChange: (location: string) => void;
  selectedServiceType: string;
}

export const ContractorsSection = ({
  contractors,
  isLoading,
  viewMode,
  onViewModeChange,
  onServiceTypeChange,
  onLocationChange,
  selectedServiceType,
}: ContractorsSectionProps) => {
  return (
    <div className="container py-12 px-4 md:px-6">
      <ContractorsList
        contractors={contractors}
        isLoading={isLoading}
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        onServiceTypeChange={onServiceTypeChange}
        onLocationChange={onLocationChange}
        selectedServiceType={selectedServiceType}
      />
    </div>
  );
};
